module.exports = __webpack_public_path__ + "img/ngerplogo.de0af759.png";